import { Global } from "./base/Global";
import { UserLogin } from "./components/UserLogin";
import { Benchmark } from "./components/Benchmark";
import { Contracts } from "./components/Contracts";
import { AccountStatements } from "./components/AccountStatements";
import { CoOpStatements } from "./components/CoOpStatements";
import { SettlementPrices } from "./components/SettlementPrices";
import { Crops } from "./components/crops";
import { Deliveries } from "./components/Deliveries";
import { Samples } from "./components/Samples";
import { CleanedSeeds } from "./components/CleanedSeeds";
import { ActiveCrops } from "./components/ActiveCrops";
import { Contact } from "./components/Contact";
import { ContractConditions } from "./components/ContractConditions";
import { TaskHandler } from "./components/TaskHandler";
import { Impersonation } from "./components/Impersonation";
import { Terms } from "./components/Terms";
import { AreaSettings } from "./components/AreaSettings";
import { OsrTrades } from "./components/OsrTrades";
import { OsrDeliveries } from "./components/OsrDeliveries";
import { OsrSamples } from "./components/OsrSamples";
import { ChangeMasterData } from "./components/ChangeMasterData";
import { LatestDocuments } from "./components/LatestDocuments";
import { StorageCrops } from "./components/StorageCrops";
import { TypeNewPassword } from "./components/TypeNewPassword";
import { GrowerSegment } from "./components/GrowerSegment";

$(document as any).ready(() => {
    const global = new Global();
    global.init();
});
export { UserLogin, Benchmark, Contracts, AccountStatements, CoOpStatements, SettlementPrices, Crops, Deliveries, Samples, CleanedSeeds, ActiveCrops, ContractConditions, Contact, TaskHandler, Impersonation, Terms, AreaSettings, OsrTrades, OsrDeliveries, OsrSamples, ChangeMasterData, LatestDocuments, StorageCrops, TypeNewPassword, GrowerSegment }